/**
 * Track Classification
 *
 * Static mapping of circuit slugs to track types.
 * Used for track-type performance analysis.
 */

import type { TrackType } from "./types";

export const TRACK_CLASSIFICATION: Record<string, TrackType> = {
  // Street circuits
  monaco: "street",
  singapore: "street",
  jeddah: "street",
  "saudi-arabia": "street",
  baku: "street",
  azerbaijan: "street",
  las_vegas: "street",
  "las-vegas": "street",
  miami: "street",

  // High-speed circuits
  monza: "high_speed",
  italy: "high_speed",
  spa: "high_speed",
  belgium: "high_speed",
  silverstone: "high_speed",
  "great-britain": "high_speed",
  interlagos: "high_speed",
  "sao-paulo": "high_speed",
  brazil: "high_speed",

  // Technical circuits
  hungary: "technical",
  budapest: "technical",
  barcelona: "technical",
  spain: "technical",
  zandvoort: "technical",
  netherlands: "technical",

  // Mixed circuits (everything else)
  bahrain: "mixed",
  australia: "mixed",
  melbourne: "mixed",
  japan: "mixed",
  suzuka: "mixed",
  china: "mixed",
  shanghai: "mixed",
  imola: "mixed",
  "emilia-romagna": "mixed",
  canada: "mixed",
  montreal: "mixed",
  austria: "mixed",
  spielberg: "mixed",
  mexico: "mixed",
  "mexico-city": "mixed",
  qatar: "mixed",
  lusail: "mixed",
  "abu-dhabi": "mixed",
  abu_dhabi: "mixed",
  usa: "mixed",
  austin: "mixed",
  "united-states": "mixed",
};

/**
 * Get the track type classification for a given race slug.
 * Returns "mixed" as default for unclassified tracks.
 */
export function getTrackClassification(raceSlug: string): TrackType {
  return TRACK_CLASSIFICATION[raceSlug] ?? "mixed";
}
